import { render } from "./ArrivalShow.vue?vue&type=template&id=5ecf1a98"
import script from "./ArrivalShow.vue?vue&type=script&lang=js"
export * from "./ArrivalShow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__